import styled from "styled-components";
import { Col, Row } from "antd";
import { WrapGlobe } from "@/components/customs/Map/mapGlobeWrapper";
import { RATypography, RAImage } from "@/components/customs";
import { useEffect, useRef, useState } from "react";
import { AIRCRAFT_RANGE_STEP } from "../index";
import { IconAircraftFillSvg } from "@/assets/images";
export function AircraftRange({
	centerAiport,
	range = 0,
	routes = [],
	step = AIRCRAFT_RANGE_STEP.FIRST,
	description = "",
	onSwipeDown,
	onSwipeUp,
}) {
	const [selectedRoute, setSelectedRoute] = useState(null);
	const [windowsSizes, setWindowsSizes] = useState({
		width: 0,
		height: 0,
	});
	const [maxRoutes, setMaxRoutes] = useState([]);
	const routesRef = useRef(null);

	const animationRef = useRef(null);

	useEffect(() => {
		setWindowsSizes({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	}, []);
	useEffect(() => {
		if (step === AIRCRAFT_RANGE_STEP.FIRST) {
			setSelectedRoute(null);
		}
	}, [step]);

	useEffect(() => {
		if (window.innerHeight >= 960) {
			setMaxRoutes(routes.slice(0, 5));
		} else if (window.innerHeight >= 830) {
			setMaxRoutes(routes.slice(0, 3));
		} else {
			setMaxRoutes(routes.slice(0, 3));
		}
	}, [routes]);

	useEffect(() => {
		var xDown = null;
		var yDown = null;

		function getTouches(evt) {
			return (
				evt.touches || // browser API
				evt.originalEvent.touches
			); // jQuery
		}

		function handleTouchStart(evt) {
			const firstTouch = getTouches(evt)[0];
			xDown = firstTouch.clientX;
			yDown = firstTouch.clientY;
		}

		function handleTouchMove(evt) {
			if (!xDown || !yDown) {
				return;
			}
			var xUp = evt.touches[0].clientX;
			var yUp = evt.touches[0].clientY;

			var xDiff = xDown - xUp;
			var yDiff = yDown - yUp;

			if (Math.abs(xDiff) > Math.abs(yDiff)) {
				/*most significant*/
				if (xDiff > 0) {
					/* right swipe */
				} else {
					/* left swipe */
				}
			} else {
				if (
					step === AIRCRAFT_RANGE_STEP.SECOND &&
					document.getElementById("routes-container")?.contains(evt.target)
				) {
					if (yDiff > 0) {
						/* down swipe */
						onSwipeDown?.();
					} else {
						/* up swipe */
						onSwipeUp?.();
					}
				}
			}
			/* reset values */
			xDown = null;
			yDown = null;
		}

		if (typeof window !== "undefined") {
			if ("ontouchstart" in window) {
				window.addEventListener("touchstart", handleTouchStart);
				window.addEventListener("touchmove", handleTouchMove);
			}
		}
		return () => {
			window.removeEventListener("touchstart", handleTouchStart);
			window.removeEventListener("touchmove", handleTouchMove);
		};
	}, [step]);

	return (
		<Container>
			<div
				style={{
					position: "relative",
					display: "flex",
					transition: "all 1s",
					flexDirection: "column",
					height: "100%",
					overflow: "hidden",
					width: "100%",
				}}
			>
				<div
					style={{
						position: "absolute",
						flex: 1,
						width: "100%",
						height: "100%",
						display: "flex",
						justifyContent: "center",
						transition: "all 0.6s",
					}}
				>
					<IntroductionSection step={step} windowsSizes={windowsSizes}>
						<RATypography
							variant="h3"
							style={{
								transition: "all 1s",
								width: "100%",
								textAlign: step === AIRCRAFT_RANGE_STEP.FIRST ? "center" : "left",
								paddingLeft: step === AIRCRAFT_RANGE_STEP.FIRST ? 0 : "20px",
								borderLeft:
									step === AIRCRAFT_RANGE_STEP.FIRST ? "1px solid transparent" : "1px solid #ffb11a",
							}}
						>
							Aircraft Range
						</RATypography>
						<RATypography
							variant="body3"
							top="20px"
							color="#595959"
							style={{
								transition: "all 1s",
								width: "100%",
								textAlign: step === AIRCRAFT_RANGE_STEP.FIRST ? "center" : "left",
							}}
						>
							{description}
						</RATypography>
						<div
							ref={routesRef}
							id="routes-container"
							style={{
								width: "100%",
								transition: "all 1s",
								transform: step === AIRCRAFT_RANGE_STEP.SECOND ? "translateX(0)" : "translateX(100vw)",
								// transitionDelay: "0.6s",
								zIndex: 1,
							}}
						>
							{maxRoutes?.map((route, index) => {
								const {
									from_airport,
									from_city_name,
									to_airport,
									to_city_name,
									fly_hours = 0,
									fly_minutes = 0,
									distance,
								} = route;
								const getHours = () => {
									let value = Number.parseFloat(fly_hours + fly_minutes / 60).toFixed(1);
									return value;
								};
								return (
									<WrapperComfort
										key={index}
										style={{
											border:
												selectedRoute?._id === index
													? "1px solid #FFB11A"
													: "1px solid #e9e8e8",
										}}
										onClick={() => {
											if (selectedRoute?._id === index) {
												setSelectedRoute(null);
											} else {
												setSelectedRoute({
													start: from_airport,
													end: to_airport,
													_id: index,
												});
											}
										}}
									>
										<Row align="middle">
											<Col span={9}>
												<RATypography variant="sub-heading3">
													{from_city_name || from_airport?.location?.city || ""}
												</RATypography>
											</Col>
											<Col
												span={6}
												style={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												<AircraftLine />
												<RAImage
													url={IconAircraftFillSvg}
													width={40}
													height={40}
													sizes="40px"
												/>
											</Col>
											<Col span={9}>
												<RATypography
													variant="sub-heading3"
													// align="right"
												>
													{to_city_name || to_airport?.location?.city || ""}
												</RATypography>
											</Col>
										</Row>
										{selectedRoute?._id === index && (
											<Row align="middle" justify="center">
												<RangeCol>
													<Row align="middle" justify="center">
														<RangeText>
															{`${getHours()} hours - ${distance} miles`}
														</RangeText>
													</Row>
												</RangeCol>
											</Row>
										)}
									</WrapperComfort>
								);
							})}
						</div>
					</IntroductionSection>
				</div>
				<GlobeSection
					step={step}
					windowsSizes={windowsSizes}
					// id="globe-container"
					// id="snap-disabled"
				>
					<div
						style={{
							transition: "all 1s",
							transform: step === AIRCRAFT_RANGE_STEP.SECOND ? "none" : "rotate(90deg)",
						}}
					>
						<WrapGlobe
							centerAiport={centerAiport}
							range={range}
							routes={routes}
							scrollDir={step === AIRCRAFT_RANGE_STEP.FIRST ? "up" : "down"}
							selectedRoute={selectedRoute}
						/>
					</div>
				</GlobeSection>
			</div>
		</Container>
	);
}

const EachPage = styled.div`
	height: 100%;
	position: relative;
`;
const Container = styled.div`
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	transition: all 0.6s linear;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row-reverse;
	z-index: 10;
	@keyframes slide-out {
		0% {
			transform: translateX(0%);
		}
		100% {
			transform: translateX(100%);
		}
	}

	@-webkit-keyframes slide-out {
		0% {
			-webkit-transform: translateX(0%);
		}
		100% {
			-webkit-transform: translateX(100%);
		}
	}

	@keyframes slide-in {
		0% {
			-webkit-transform: translateX(100%);
		}
		100% {
			-webkit-transform: translateX(0%);
		}
	}

	@-webkit-keyframes slide-in {
		0% {
			transform: translateX(100%);
		}
		100% {
			transform: translateX(0%);
		}
	}
`;
const WrapperComfort = styled.div`
	padding: 24px;
	width: 100%;
	min-height: 72px;
	border-radius: 10px;
	margin-top: 20px;
	z-index: 100;
	position: relative;
	cursor: pointer;
	&:hover {
		border-color: #ffb11a;
	}
`;
const AircraftLine = styled.div`
	position: absolute;
	width: 100%;
	height: 1px;
	left: 0;
	top: 20px;
	border: 1px dashed #e9e8e8;
`;
const RangeCol = styled(Col)`
	padding: 6px 20px;
	background: #f9f9f9;
	border-radius: 30px;
`;
const RangeText = styled.span`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
	color: #595959;
`;

const IntroductionSection = styled.div`
	max-width: 572px;
	transition: all 0.6s;
	/* padding: 5vh 0 0 0; */
	padding: ${({ step, windowsSizes }) =>
		step === AIRCRAFT_RANGE_STEP.FIRST
			? "5vh 0 0 0"
			: `${windowsSizes.height >= 1000 ? "5vh 0 0 0" : "120px 0 0 0"}`};
	width: 100%;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	z-index: 2;
	transform: ${({ step, windowsSizes }) =>
		step === AIRCRAFT_RANGE_STEP.FIRST
			? "transform: translate(0%, 84px)"
			: `translate(calc(50% + 70px), ${(windowsSizes.height - 1000 - 84) / 2}px)`};
	-webkit-transform: ${({ step, windowsSizes }) =>
		step === AIRCRAFT_RANGE_STEP.FIRST
			? "transform: translate(0%, 84px)"
			: `translate(calc(50% + 70px), ${(windowsSizes.height - 1000 - 84) / 2}px)`};
	@media (max-width: 1600px) {
		max-width: 437px;

		transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "transform: translate(0%, 84px)"
				: `translate(calc(50% + 70px), ${(windowsSizes.height - 900 - 84) / 2}px)`};
		-webkit-transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "transform: translate(0%, 84px)"
				: `translate(calc(50% + 70px), ${(windowsSizes.height - 900 - 84) / 2}px)`};
	}

	@media (max-width: 1200px) {
		max-width: 437px;
		transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "transform: translate(0%, 84px)"
				: `translate(calc(50% + 70px), ${(windowsSizes.height - 800 - 84) / 2}px)`};
		-webkit-transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "transform: translate(0%, 84px)"
				: `translate(calc(50% + 70px), ${(windowsSizes.height - 800 - 84) / 2}px)`};
	}
`;

const GlobeSection = styled.div`
	transition: all 0.6s;
	width: 100%;
	position: absolute;
	z-index: ${({ step }) => (step === AIRCRAFT_RANGE_STEP.FIRST ? 0 : 1)};
	transform: ${({ step, windowsSizes }) =>
		step === AIRCRAFT_RANGE_STEP.FIRST
			? "translate(0%, 40%)"
			: `translate(-570px, ${(windowsSizes.height - 1000 - 84) / 2}px)`};
	@media (max-width: 1600px) {
		transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "translate(0%, 40%)"
				: `translate(-520px, ${(windowsSizes.height - 900 - 84) / 2}px)`};
	}

	@media (max-width: 1200px) {
		transform: ${({ step, windowsSizes }) =>
			step === AIRCRAFT_RANGE_STEP.FIRST
				? "translate(0%, 40%)"
				: `translate(-470px, ${(windowsSizes.height - 800 - 84) / 2}px)`};
	}
`;
